import { createContext, useContext } from 'react'

interface IObjectContext {
    past: boolean
    _id: string
    sectionID: string
    visibility?: string
}

const ObjectContext = createContext<IObjectContext>({
    past: false,
    _id: '',
    sectionID: '',
})
interface IObjectProviderProps {
    children: React.ReactNode
    past: boolean
    _id: string
    sectionID: string
    visibility?: string
}
export const ObjectProvider = (props: IObjectProviderProps) => {
    return (
        <ObjectContext.Provider
            value={{
                past: props.past,
                _id: props._id,
                sectionID: props.sectionID,
                visibility: props.visibility,
            }}
        >
            {props.children}
        </ObjectContext.Provider>
    )
}
export const useObjectContext = () => {
    return useContext(ObjectContext)
}
